<template>
  <div>
    <template v-for="item in categoryItems" :key="item.id">
      <MobileNavigationAccordionItem
        :category="item"
        :additional-links="getAdditionalLinks(item)"
        :content-links="getContentLinks(item)"
        :depth="1"
        @click:item="goToCategory"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { computed } from 'vue'
import type { NavigationItem } from '~/types/navigation'

const props = defineProps({
  navigationItems: {
    type: Array as PropType<NavigationItem[]>,
    required: true,
  },
})

const emit = defineEmits<{
  (e: 'click:item', value: string): void
}>()

const goToCategory = (path: string) => {
  emit('click:item', path)
}

const getAdditionalLinks = (item: NavigationItem) => {
  if (!item.NavigationItem?.length) return undefined
  return {
    _uid: item.id.toString(),
    component: 'MainNavigation' as const,
    NavigationItem: item.NavigationItem,
  }
}

const getContentLinks = (item: NavigationItem) => {
  return item.NavigationFlyoutContent || []
}

const categoryItems = computed(() =>
  props.navigationItems.map((item) => ({
    ...item,
    id: Number(item.id),
    children: item.children || [],
  })),
)
</script>
